<template>
  <div class="page-title">

    <div class="row">
      <div class="col-sm-6 col-12">
        <h2> All Dispatch Users</h2>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
          <DataTable
              :ajax="{ url: dispatchUserUrl}"
              ref="orderedRides" class="table-responsive display" :columns="dispatcherColumns"/>
    </div>
  </div>
</template>

<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {booleanBadgeRender, driverStatus, userDetailsWithThumbnail, zonedDateTime} from "../utility/DatatableRenderer";
import {newEntityId} from '../globals.js';
DataTable.use(DataTablesCore);

const props = defineProps({
  serviceProviderId: { type: String, default: newEntityId }
});

const dispatchUserUrl = `/api/datatable/sp-dispatch-users/${props.serviceProviderId}`;


// Define columns
const dispatcherColumns = [
  {data: 'fullName', title: 'Name'},
  {data: 'email', title: 'Email'},
  {data: 'isAdminUser', title: 'Admin User', render: booleanBadgeRender},
  {
    title: 'Actions', orderable: false, searchable: false, render: (data, type, row) => {
      return `<a class="btn btn-outline-primary" data-id="${row.id}"
                href="/service-provider/${props.serviceProviderId}/dispatch-user/${row.id}">
                Details <i class="fa-solid fa-arrow-up-right-from-square"></i> </a>`;
    }
  }
];


</script>